export default "__VITE_ASSET__6b9e767f__"